export default "__VITE_ASSET__C7$LdEZU__"